/** @format */
import { Component, inject, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { LocalizedString } from 'common-typescript/types';

interface PaymentStartedWarningValues {
    instructionsUrl: LocalizedString;
}
export function paymentStartedWarningDialogOpener(): (data: PaymentStartedWarningValues) => MatDialogRef<PaymentStartedWarningComponent> {
    const fudisDialogService = inject(FudisDialogService);
    return data => fudisDialogService.open(PaymentStartedWarningComponent, { data });
}

@Component({
    selector: 'app-payment-started-warning-dialog',
    templateUrl: './payment-started-warning-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class PaymentStartedWarningComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PaymentStartedWarningValues,
        private dialogService: FudisDialogService,
    ) {}

    closeDialog() {
        this.dialogService.close();
    }
}
